import VueMap from './src/components/VueMap'


export { VueMap }

export default {
  components: {
    vueMap: VueMap
  },
  install: function (Vue, options) {
    Vue.component('VueMap', VueMap)
  }
}